import * as actionTypes from 'constants/ActionTypes';

export function getAnalyticsLinksList() {
    return {
        type: actionTypes.GET_ANALYTICS_LINKS_LIST.REQUEST,
    };
}



// WEBPACK FOOTER //
// ./app/actions/analytics/linksList.js